import { Play, Award } from "lucide-react";
import { SITE } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

const VideoCard = ({ id, title, subtitle, testid }) => (
  <a
    href={`https://www.youtube.com/watch?v=${id}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="group rounded-2xl border border-white/10 bg-[#0B261E]/60 overflow-hidden transition-[border-color,transform] duration-300 hover:border-[#00E676]/45 hover:-translate-y-1.5 block"
  >
    <div className="relative aspect-video overflow-hidden">
      <img
        src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
        alt={title}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-108"
      />
      <div className="absolute inset-0 bg-[#04120E]/35 group-hover:bg-[#04120E]/15 transition-colors duration-300" />
      <span className="absolute inset-0 grid place-items-center">
        <span className="grid place-items-center w-14 h-14 rounded-full bg-[#00E676] text-[#04120E] shadow-[0_0_26px_rgba(0,230,118,0.55)] transition-transform duration-300 group-hover:scale-110">
          <Play size={20} className="ml-0.5" />
        </span>
      </span>
    </div>
    <div className="p-5">
      <p className="text-xs font-mono2 uppercase tracking-widest text-[#00E676]">{subtitle}</p>
      <p className="mt-1.5 text-sm font-semibold text-white leading-snug">{title}</p>
    </div>
  </a>
);

export const Media = () => (
  <section className="relative py-24 sm:py-32 bg-[#061A14]" data-testid="media-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Na mídia</Overline>
        <SectionTitle className="max-w-3xl">
          Energia solar por assinatura <Accent>é notícia</Accent>.
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/55">
          A Conexão Green, da iGreen, já foi tema de reportagem na TV, e o modelo de energia por assinatura aparece cada vez mais nos telejornais.
        </p>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SITE.mediaVideos.map((v, i) => (
          <Reveal key={v.id} delay={i * 0.1}>
            <VideoCard id={v.id} title={v.title} subtitle={v.channel} testid={`media-video-${i}`} />
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-[11px] text-emerald-100/40 max-w-3xl leading-relaxed">
        As reportagens do Jornal da Cultura e da Canção Nova, publicadas pelas próprias emissoras, falam do modelo de
        energia solar por assinatura em geral, não especificamente da iGreen.
      </p>

      <Reveal delay={0.1}>
        <div className="mt-20 grid lg:grid-cols-2 gap-10 items-center rounded-3xl border border-[#A3E635]/25 bg-[#0B261E]/50 p-8 sm:p-12" data-testid="reclame-aqui-section">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-mono2 uppercase tracking-[0.25em] text-[#A3E635] mb-4">
              <Award size={14} /> Reconhecimento
            </p>
            <h3 className="font-heading text-xl sm:text-2xl lg:text-3xl font-bold text-white leading-tight">
              Atendimento <span className="text-[#A3E635]">premiado</span> pelo Reclame Aqui.
            </h3>
            <p className="mt-4 text-sm sm:text-base text-emerald-100/60 leading-relaxed max-w-lg">
              A iGreen Energy recebeu o selo RA1000 e foi indicada ao Prêmio Reclame Aqui 2025 na categoria Experiência
              do Cliente. No vídeo, a própria equipe conta como resolve as reclamações.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 rounded-xl border border-[#A3E635]/30 bg-[#04120E]/60 px-5 py-3">
              <span className="font-heading text-2xl font-extrabold text-[#A3E635]">RA1000</span>
              <span className="text-xs text-emerald-100/60 leading-tight">Selo de excelência<br />em atendimento</span>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
            <div className="aspect-video">
              <iframe
                src={`https://www.youtube.com/embed/${SITE.reclameAquiVideoId}?rel=0`}
                title="Reclame Aqui RA1000 iGreen"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
